/* eslint-disable import/prefer-default-export */

/*
 * General Getters
 */

export const FORMAT_ID = 'FORMAT_ID';
export const CARD_DATA_AS_JSON_STRING = 'CARD_DATA_AS_JSON_STRING';
export const KARTENDESIGNER_VISIBLE = 'KARTENDESIGNER_VISIBLE';
export const IS_PRINT_MODE = 'IS_PRINT_MODE';
export const IS_SCREENSHOT_MODE = 'IS_SCREENSHOT_MODE';
export const CARD_ID = 'CARD_ID';
export const SESSION_ID = 'SESSION_ID';
export const GET_TEXT = 'GET_TEXT';
export const BLEED_AMOUNT = 'BLEED_AMOUNT';
export const EDGE_USES_BLEED = 'EDGE_USES_BLEED';
export const IS_UNSUPPORTED_DEVICE_OR_RESOLUTION = 'IS_UNSUPPORTED_DEVICE_OR_RESOLUTION';
export const SCALE = 'SCALE';
export const PAPER_ID = 'PAPER_ID';
export const WINDOW_WIDTH = 'WINDOW_WIDTH';
export const WINDOW_HEIGHT = 'WINDOW_HEIGHT';

/*
 * Side Getters
 */

export const SIDES = 'SIDES';
export const SIDE_IDS = 'SIDE_IDS';
export const ACTIVE_SIDE = 'ACTIVE_SIDE';
export const ACTIVE_SIDE_ID = 'ACTIVE_SIDE_ID';
export const GET_SIDE_BY_ID = 'GET_SIDE_BY_ID';

/*
 * Active Layer Getters
 */

export const ACTIVE_LAYER = 'ACTIVE_LAYER';
export const ACTIVE_LAYER_ID = 'ACTIVE_LAYER_ID';
export const ACTIVE_LAYER_TYPE = 'ACTIVE_LAYER_TYPE';
export const ACTIVE_LAYER_BOUNDING_CLIENT_RECT = 'ACTIVE_LAYER_BOUNDING_CLIENT_RECT';

/*
 * Image / Foto Layer Getters
 */
export const ACTIVE_IMAGE_URL = 'ACTIVE_IMAGE_URL'; /* selected image (foto), might be a blob in the future */
export const GET_IMAGE_LAYER_DPI_FOR_ACTIVE_LAYER = 'GET_IMAGE_LAYER_DPI_FOR_ACTIVE_LAYER';
export const USER_IMAGES = 'USER_IMAGES';

/*
 * Theme Getters
 */
export const THEME_COLORS = 'THEME_COLORS';
export const ACTIVE_THEME = 'ACTIVE_THEME';
export const THEME_FONT_COLORS = 'THEME_FONT_COLORS';

/*
 * Tooltip Getters
 */
export const TOOLTIPS_VISIBLE = 'TOOLTIPS_VISIBLE';
export const TOOLTIPS = 'TOOLTIPS';
export const LAYER_IS_FIRST_OF_TYPE = 'LAYER_IS_FIRST_OF_TYPE';

/*
 * Preview Getters
 */
export const PREVIEW_VISIBLE = 'PREVIEW_VISIBLE';
export const PREVIEW_IMAGE_FOR_SIDE_WITH_ID = 'PREVIEW_IMAGE_FOR_SIDE_WITH_ID';
export const PREVIEW_IMAGES_LOADED = 'PREVIEW_IMAGES_LOADED';

/*
 * Checkout / PDF getters
 */
export const WAITING_FOR_PDF = 'WAITING_FOR_PDF';

/*
 * Shop URL Getters
 */
export const SHOP_URL = 'SHOP_URL';

/*
 * Printing Getters
 */
export const PRINT_SHOP_NOTES_BY_SIDE_ID = 'PRINT_SHOP_NOTES_BY_SIDE_ID';

/*
 * Layout Mode Getters
 */
export const LAYOUT_MODE_ACTIVE = 'LAYOUT_MODE_ACTIVE';
